<template>
  <div id="manager-noAuth">
    无权限
  </div>
</template>

<script>
export default {
  name: 'manager-noAuth',
  components: {
  },
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
</style>
